import type React from 'react';

import { JsonSchemaInput } from '@ragu-components/json-schema-input';
import { OrdSimpleForm, OrdTabbedForm, OrdFormList, OrdIconStandard } from '@ragu-components/ord-components';
import { CalendarUpdateFields, PersonalCalendarUpdateFields, dataSchema } from '@ragu-components/ord-types';
import { TabbedForm } from 'react-admin';

import { OrdDescriptionInput } from 'src/components/formInputs';

import type { OrdTabbedFormProps, OrdSimpleFormProps } from '@ragu-components/ord-components';

export const PersonalCalendarsForm = (props: OrdSimpleFormProps): React.ReactElement => (
  <OrdSimpleForm
    sanitizeFields
    replaceRelationships
    createJsonSchema={dataSchema.PersonalCalendarCreate}
    editJsonSchema={dataSchema.PersonalCalendarUpdate}
    {...props}
  >
    <OrdFormList icon={<OrdIconStandard name='calendars' />}>
      <JsonSchemaInput source={PersonalCalendarUpdateFields.title} />
      <OrdDescriptionInput source={PersonalCalendarUpdateFields.description} />
    </OrdFormList>
  </OrdSimpleForm>
);

export const CalendarsForm = (props: OrdTabbedFormProps): React.ReactElement => (
  <OrdTabbedForm
    sanitizeFields
    replaceRelationships
    createJsonSchema={dataSchema.CalendarCreate}
    editJsonSchema={dataSchema.CalendarUpdate}
    {...props}
  >
    <TabbedForm.Tab label='resources.calendars.operations.sections.details'>
      <OrdFormList icon={<OrdIconStandard name='calendars' />}>
        <JsonSchemaInput source={CalendarUpdateFields.title} />
        <OrdDescriptionInput source={CalendarUpdateFields.description} />
      </OrdFormList>
    </TabbedForm.Tab>
  </OrdTabbedForm>
);
